import { ChangeDetectorRef, Component, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { SubmenuItem } from 'sharedFeatures/submenu';
import { PopupComponent } from 'sharedFeatures/window';
import { Utils } from 'sharedFeatures/utils';

declare var jQuery: any;

@Component({
    selector: 'submenu-dropdown-popup',
    templateUrl: './submenu-dropdown-popup.component.html',
    styleUrls: ['./submenu-dropdown-popup.component.less']
})
export class SubmenuDropdownPopupComponent extends PopupComponent {

    public itemDiv: HTMLElement | undefined;
    items: Array<SubmenuItem> = [];
    protected itemClickCallback: Function | undefined;

    private clickUnlisten: Function | undefined;

    constructor(element: ElementRef,
        r: Renderer2,
        viewContainerRef: ViewContainerRef,
        chDet: ChangeDetectorRef
    ) {
        super(element, r, viewContainerRef, chDet);
        this.width = -1;
        this.height = -1;

        this.cornerRadius = 0;
        this.isModal = false;

        this.backgroundFill = 'transparent';

        let topZIndex = jQuery.topZIndex(Utils.zIndexSelector);

        if (topZIndex >= 2147483647) // Sometimes topZIndex() returns 2147483647 - it's a max z─index value
            topZIndex -= 1;

        this.r.setStyle(this.getElDom(), 'zIndex', topZIndex + 1);

        this.clickUnlisten = this.r.listen(document, 'click',
            ev => this.handleDocumentClick(ev));
    }

    ngOnDestroy() {
        if (this.clickUnlisten)
            this.clickUnlisten();
    }
    public init(itemDiv: HTMLElement, items: Array<SubmenuItem> | undefined, itemClickCallback: Function): void {
        this.itemDiv = itemDiv;
        this.items = items ? items : [];
        this.itemClickCallback = itemClickCallback;
    }

    // Ivy has bug, event is raised multiply times if inherited component has any @HostListener
    //@HostListener('document:click', ['$event'])
    public handleDocumentClick(event: MouseEvent) {
        // If click was out of popup or tab item then close popup
        if (!this.getElDom().contains(<Node>event.target) &&
            !(this.itemDiv && this.itemDiv.contains(event.target as any))) {
            this.close();
        }
    }

    handleItemClick(item: SubmenuItem): void {
        // Pass item to parent component
        if (this.itemClickCallback)
            this.itemClickCallback(item);

        this.close();
    }
}